import {
  styled,
  Theme,
  Tooltip,
  tooltipClasses,
  TooltipProps,
} from '@mui/material';

export const AurLightTooltip = styled(({className, ...props}: TooltipProps) => (
  <Tooltip
    classes={{popper: className, arrow: 'custom-arrow'}}
    placement="top"
    arrow
    describeChild
    {...props}
  />
))(({theme}: {theme: Theme}) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    marginTop: -11,
  },
}));
